export enum UrlStatus {
  Successful = 0,
  Failed = 1
}
